import React from 'react';
import { Scissors, Calendar } from 'lucide-react';
import { Button } from './ui/button';
import { services, barbershopInfo } from '../data/mock';

const ServicesSection = () => {
  return (
    <section id="services" className="py-20 sm:py-32 bg-slate-900 relative">
      {/* Background Accent */}
      <div className="absolute top-0 left-0 w-1/2 h-full bg-gradient-to-r from-[#c9a962]/5 to-transparent" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" dir="rtl">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 mb-4">
            <div className="h-px w-12 bg-[#c9a962]" />
            <Scissors className="w-5 h-5 text-[#c9a962]" />
            <div className="h-px w-12 bg-[#c9a962]" />
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            השירותים <span className="text-[#c9a962]">שלנו</span>
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            שירות מקצועי ואיכותי בהתאמה אישית לכל לקוח
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <div
              key={service.id}
              className="group relative bg-slate-950 border border-slate-800 hover:border-[#c9a962]/50 transition-all duration-500 hover:-translate-y-2 hover:shadow-xl hover:shadow-[#c9a962]/10"
            >
              {/* Price Badge */}
              <div className="absolute -top-4 right-6 bg-[#c9a962] text-slate-950 font-bold px-4 py-2 text-sm whitespace-nowrap">
                {service.priceLabel}
              </div>
              
              <div className="p-6 pt-8">
                {/* Service Number */}
                <div className="text-6xl font-bold text-slate-800 group-hover:text-[#c9a962]/20 transition-colors duration-300 mb-4">
                  0{index + 1}
                </div>
                
                <h3 className="text-xl font-bold text-white mb-3 group-hover:text-[#c9a962] transition-colors">
                  {service.name}
                </h3>
                
                <p className="text-slate-400 text-sm leading-relaxed mb-6">
                  {service.description}
                </p>
                
                {/* Divider */}
                <div className="h-px bg-gradient-to-r from-[#c9a962]/50 to-transparent mb-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                
                {/* Icon */}
                <div className="flex items-center justify-between">
                  <Scissors className="w-5 h-5 text-[#c9a962]/50 group-hover:text-[#c9a962] transition-colors" />
                  <span className="text-slate-500 text-xs">NY Barbershop</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-slate-400 mb-6">
            שעות פעילות: <span className="text-white font-semibold">{barbershopInfo.hours}</span>
            <br />
            <span className="text-[#c9a962]">{barbershopInfo.hoursNote}</span>
          </p>
          <a
            href={barbershopInfo.bookingUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button className="bg-[#c9a962] hover:bg-[#b8962f] text-slate-950 font-bold text-lg px-8 py-6 transition-all duration-300 hover:shadow-xl hover:shadow-[#c9a962]/30">
              <Calendar className="w-5 h-5 ml-2" />
              הזמן תור עכשיו
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
